import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
import ParkinglocationModel from './ParkinglocationModel.js';

const BASE = BaseModel.getApiBasePath() + '/api/v1/core/parkinglocations';

export default new class IntelliportSensorsParkinglocationsModel {

  constructor() { }

  getAll() {
    return new Promise((resolve, reject) => {
      axios.get(BASE, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          ParkinglocationModel.getAll(true)
            .then((parkingLocations) => {
              let data = [];
              parkingLocations.forEach(location => {
                data.push(Object.assign({}, { parkingLocationID: location.id, parkingLocationName: location.Code + ' - ' + location.Name, listenerName: "application/parking/" + location.id }))
              });
              resolve(data);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }


}


// WEBPACK FOOTER //
// ./src/components/IntelliportSensorsParkinglocationsModel.js